
import * as React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Brush } from 'recharts'
import { CustomMonthlyHighlightsTooltip } from '../CustomTooltip/CustomTooltip';

const style = {
  bottom: 0,
  left: 10,
  lineHeight: '24px'
};
const styleNoData = {
  ...style,
  fontSize: "1.2rem"
};
const noData = [
  { month: 0, ["No Data to Show"]: 0, },
  { month: 1, ["No Data to Show"]: 0, },
  { month: 2, ["No Data to Show"]: 0, },
  { month: 3, ["No Data to Show"]: 0, },
]
const LineChart: React.FC<any> = (props) => {

  function getStartIndexYear() {
    const startIndex = props.data.length - 5;
    return props.data && startIndex > 0 ? startIndex : 0;
  }
  let data = props.data.map((d) => {
    d.Cases = d.cases || 0;
    d.Alerts = d.alerts || 0;
    d["Alerted Cases Closed"] = d.alertedCasesClosed || 0;
    return d;
  })
  data = data.length > 0 ? data : noData;
  return (
    <>
      {data.length === 0 && <p>No Data to Show</p>}
      {data.length > 0 && <ResponsiveContainer width={'100%'} height={310}>
        <AreaChart height={400} data={props.data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip content={<CustomMonthlyHighlightsTooltip />} />
          {props.data.length > 0 && <Area type='monotone' dataKey='Cases' stroke='#2ABCCA' fill='#2ABCCA' />}
          {props.data.length > 0 && <Area type='monotone' dataKey='Alerts' stroke='#E2BC2F' fill='#E2BC2F' />}
          {props.data.length > 0 && <Area type='monotone' dataKey='Alerted Cases Closed' stroke='#D16201' fill='#D16201' />}
          {props.data.length === 0 && <Area type='monotone' dataKey='No Data to Show' stroke='grey' fill='grey' />}
          <Legend iconSize={10} width={600} height={10} layout='horizontal' wrapperStyle={props.data.length > 0 ? style : styleNoData} />
          <Brush dataKey='month' startIndex={getStartIndexYear()} height={30} stroke="#8884d8" />
        </AreaChart>
      </ResponsiveContainer>}
    </>
  )
}

export default LineChart;